export default {
  'auth.email.suggestion': 'Did you mean {email}?',
  'auth.email.typoError': 'Please check your email address.',
  'auth.email.disposableError':
    "Please use a permanent email address. We can't accept disposable addresses.",
  'auth:common:label-email': 'E-Mail',
  'auth:common:label-email:focus': 'Your email address',
  'auth:common:label-password': 'Password',
  'auth:common:label-new-password': 'New password',
  'auth:common:label-repeat-new-password': 'Repeat new password',
  'auth:common:button:to-login': 'To Login',

  'auth:activate-account:header': 'Activate account',
  'auth:activate-account:sub-header': 'Please set a password for your account',
  'auth:activate-account:account-activated': 'Your account has been activated.',
  'auth:activate-account:button:activate': 'Activate account',
  'auth:activate-account:error-message': 'An error occurred. Please try again later!',

  'auth:login:header': 'Login',
  'auth:login:header:otp': 'Login with one-time code',
  'auth:login:sheet:header': 'Welcome to Pets Deli',
  'auth:login:label:password': 'Password',
  'auth:login:button:login': 'Login',
  'auth:login:button:recover-password': 'Forgot password?',
  'auth:login:link:create-new-account': 'Create now',
  'auth:login:question:dont-you-have-an-account': 'Do not have an account yet?',

  'auth:signup:label:password': 'Password',
  'auth:signup:label:submitButton': 'Submit',
  'auth:signup:label:confirmPassword': 'Confirm password',
  'auth:signup:header-title:register': 'Sign up',
  'auth:signup:link:log-in': 'Login',
  'auth:signup:question:do-you-have-an-account': 'Do you already have an account?',
  'auth:signup:hint:min-length-12': 'Password has to be at least 12 characters.',
  'auth:signup:header': 'Sign up',
  'auth:signup:success-message': 'Account created',
  'auth:signup:show-password': 'Show password',
  'auth:signup:hide-password': 'Hide password',
  'auth:signup:ambassador-info':
    'To complete your registration as a Pets Deli Ambassador, please create a customer account first. We will then guide you through the next steps.',

  'auth:recover-password:header': 'Forgot password',
  'auth:recover-password:sub-header':
    'We have sent you an email with a link to reset your password!',
  'auth:recover-password:button:reset-confirm': 'Reset password',
  'auth:recover-password:button:back-to-login': ' Back to Login',

  'auth:reset-password:header': 'Set new password',
  'auth:reset-password:button:change': 'Change password',
  'auth:reset-password:confirm': 'Your password has been changed successfully.',
  'auth:reset-password:button:continue-purchase': 'Continue shopping',

  'auth.login-warning.country-de': 'Germany',
  'auth.login-warning.country-ch': 'Switzerland',
  'auth.login-warning.country-nl': 'the Netherlands',

  // Login Warning Messages, `country` is the country of the shop the account belongs to
  'auth:login-warning:title': 'Oh no! 🐾 Your account belongs to the shop for {country}.',
  'auth:login-warning:message':
    'Please note: Your customer account for {country} cannot be used in this shop.',
  'auth:login-warning:link': '👉 Go to the shop for {country}',
  'auth:login-warning:footer':
    'Thank you for your understanding and see you soon in the right shop! 💚',
};
